export default function createRedirectLinkFitment(part, selectedVehicle) {
  const {
    year, make, model, submodel, engine,
  } = selectedVehicle
  let url = `/search?q=${encodeURIComponent(part)}`
  if (year) {
    url = `${url}&vehicle[year]=${encodeURIComponent(year)}`
  }
  if (make) {
    url = `${url}&vehicle[make]=${encodeURIComponent(make)}`
  }
  if (model) {
    url = `${url}&vehicle[model]=${encodeURIComponent(model)}`
  }
  if (submodel) {
    url = `${url}&vehicle[submodel]=${encodeURIComponent(submodel)}`
  }
  if (engine) {
    url = `${url}&vehicle[engine]=${encodeURIComponent(engine)}`
  }
  return url
}
